import { render } from "./EcommercePage.vue?vue&type=template&id=60b4ec6c&scoped=true&ts=true"
import script from "./EcommercePage.vue?vue&type=script&lang=ts"
export * from "./EcommercePage.vue?vue&type=script&lang=ts"

import "./EcommercePage.vue?vue&type=style&index=0&id=60b4ec6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b4ec6c"]])

export default __exports__